import axios from 'axios'

/** @type {'string'} The app's BASE_API is the url of the backend */
const BASE_API = process.env.VUE_APP_BASE_API
const ADMIN_TOKEN= process.env.VUE_APP_ADMIN_TOKEN
const BASE_API_USER = process.env.VUE_APP_BASE_API_USER 

/** @type {number} - use to set the max time out of the request */
const fiveteenSecond = 15000

/** @type {object} Instantiation of the Axios Object
 *  @description - We can modified this object with our specific Headers to implements these in each request that will we make
 * or set some properties like timeout
 */
const http = axios.create({
  baseURL: BASE_API,
  timeout: fiveteenSecond,
})

const httpUser = axios.create({
  baseURL: BASE_API_USER,
  timeout: fiveteenSecond,
})

http.interceptors.request.use(
  (config) => {
      config.headers['X-S24-AdmToken'] = ADMIN_TOKEN
      config.headers['Content-Type'] = 'application/json'
    return config
  },
)

httpUser.interceptors.request.use(
  (config) => {
      config.headers['X-S24-AdmToken'] = ADMIN_TOKEN
      config.headers['Content-Type'] = 'application/json'
    return config
  },
)

export { http, httpUser }
